export const TABLE_HEADERS = [
  {},
  {
    field: 'name',
    label: 'licenses.table.headers.name',
  },
  {
    field: 'key',
    label: 'licenses.table.headers.key',
  },
  {
    field: 'link',
    label: 'licenses.table.headers.link.label',
  },
];

// students
export const MS_OFFICE_LICENSES = [
  {
    id: 1,
    name: 'Office LTSC Professional Plus 2024',
    key: 'P9NYC-M8QDJ-YJY69-7JC2T-687GD ',
    link: 'https://moedistro.blob.core.windows.net/isos/Office2024-LTSC-ProPlusEnBgx64.zip',
  },
  {
    id: 2,
    name: 'Office LTSC Standard 2024',
    key: 'ND77C-YWW3C-FT2B3-T96GY-RC6J8 ',
    link: 'https://moedistro.blob.core.windows.net/isos/Office2024-LTSC-StdEnBg-x64.zip',
  },
  {
    id: 3,
    name: 'Office LTSC Professional Plus 2021',
    key: '2DGXH-6NC4B-HJCQK-RRHM3-Y4KJ9 ',
    link: 'https://moedistro.blob.core.windows.net/isos/Office2021-LTSC-ProPlusEnBg-x64.zip',
  },
  {
    id: 4,
    name: 'Office LTSC Standard 2021',
    key: 'WM9KF-YVND3-W6T69-WXKRG-3V9KH ',
    link: 'https://moedistro.blob.core.windows.net/isos/Office2021-LTSC-StdEnBg-x64.zip',
  },
  {
    id: 5,
    name: 'Office Professional Plus 2019',
    key: '7TH7N-BK3P4-DGWV6-69VJJ-JFJKQ ',
    link: 'https://moedistro.blob.core.windows.net/isos/Office_Deployment_Tools_2019_-3_MLF_X22-09817.EXE',
  },
  {
    id: 6,
    name: 'Office Standard 2019',
    key: '2FGNM-T62DH-23Y8W-PCMWK-QV8KY',
    link: 'https://moedistro.blob.core.windows.net/isos/Office2019-StdEnBg-x64.zip',
  },
  {
    id: 7,
    name: 'OfOffice Professional Plus 2016',
    key: 'YNTQV-2B28Q-CG7HG-P2WXP-76DMB',
    link: 'https://moedistro.blob.core.windows.net/isos/SW_DVD5_Office_Professional_Plus_2016_W32_Bulgarian_MLF_X20-41322.ISO',
  },
  {
    id: 8,
    name: 'Office Professional Plus 2013',
    key: 'WNQW3-6T4KK-TD3G7-8JCBD-3PCDH',
    link: 'https://moedistro.blob.core.windows.net/isos/SW_DVD5_Office_Professional_Plus_2013w_SP1_32-BIT_X64_Bulgarian_MLF_X19-35886.ISO',
  },
];

// teachers
export const WINDOWS_LICENSES = [
  {
    id: 1,
    name: 'Windows 11 Education',
    key: '49NVM-K3GYJ-QHV66-MJRWY-JK8WD',
    link: 'https://moedistro.blob.core.windows.net/isos/en-us_windows_11_business_editions_version_22h2_updated_oct_2022_x64_dvd_080047de.iso',
  },
  {
    id: 2,
    name: 'Windows 11 Pro / Windows 11 Pro for Workstations ',
    key: 'B3QNW-8FDJX-4V2JR-VP7BG-HFR9M',
    link: 'https://moedistro.blob.core.windows.net/isos/en-us_windows_11_business_editions_version_22h2_updated_oct_2022_x64_dvd_080047de.iso',
  },
  {
    id: 3,
    name: 'Windows 10 Education',
    key: '49NVM-K3GYJ-QHV66-MJRWY-JK8WD ',
    link: 'https://moedistro.blob.core.windows.net/isos/SW_DVD9_Win_Pro_10_1903_64BIT_English_Pro_Ent_EDU_N_MLF_X22-02890.ISO',
  },
  {
    id: 4,
    name: 'Windows 10 Pro / Windows 10 Pro for Workstations',
    key: 'B3QNW-8FDJX-4V2JR-VP7BG-HFR9M',
    link: 'https://moedistro.blob.core.windows.net/isos/SW_DVD9_Win_Pro_10_1903_64BIT_English_Pro_Ent_EDU_N_MLF_X22-02890.ISO',
  },
  {
    id: 5,
    name: 'Windows 10 Enterprise LTSC 2021',
    key: '2FYFN-DYC99-HG7RC-CQ8XF-9W62P',
    link: 'https://moedistro.blob.core.windows.net/isos/SW_DVD5_WIN_ENT_LTSC_2019_32BIT_English_-2_MLF_X22-05018%20(1).ISO',
  },
];

export const OFFICE_APPLICATIONS_PACKAGE = [
  'Microsoft Word',
  'Microsoft Excel',
  'Microsoft Outlook',
  'Microsoft Power Point',
  'Microsoft One Note',
];

export const OFFICE_365_EDUCATION = [
  "Word", "Excel", "PowerPoint", "OneNote", "Microsoft Teams", "Microsoft 365", "Copilot Chat"
]